function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "100%",
  x2: "50%",
  y2: "0%",
  id: "b"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E4755C",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CE5178",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M37.8 11.353c2.314 0 4.2 1.902 4.2 4.235v21.177C42 39.098 40.114 41 37.8 41H4.2C1.882 41 0 39.098 0 36.765V9.235C0 6.902 1.882 5 4.2 5h9.45c1.315 0 2.572.633 3.36 1.696l3.465 4.657H37.8zM4 37h34l-.002-21.538h-17.53a4.253 4.253 0 0 1-3.402-1.724L14.736 9H4v28z",
  fill: "#767E9D"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  d: "M5.849.148V26.89L9.8 22.94l4.442 4.44V.149z"
}));

var SvgEmptyCollections = function SvgEmptyCollections(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyCollections, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/EmptyCollections.87a4b975.svg";
export { ForwardRef as ReactComponent };